const e = "";
export {
  e as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/configuration-goods/components/GroundMass/index.vue3.js
// module id = 1195
// module chunks = 41